/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { RawEvent } from '../../../interface/eventInterface';
import { Tracker } from '../trackers';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: any;
  }
}

export class GTMTracker implements Tracker {
  private gtmIDs: string[];

  constructor(gtmIDs: string[]) {
    if (gtmIDs.length === 0) {
      throw new Error('GTMTracker requires at least one GTM ID.');
    }
    this.gtmIDs = gtmIDs;
  }

  Init(): void {
    this.injectScript();
  }

  private injectScript() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    this.gtmIDs.forEach(gtmID => {
      (function (w: any, d: any, s: any, l: any, i: any) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', gtmID);
    });

    window.gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    });
  }

  TrackEvent(_event: RawEvent): void {
    this.gtmIDs.forEach(gtmID => {
      const eventName = (() => {
        switch (_event.eventName) {
          case 'InitiateCheckout':
            return 'begin_checkout';
          case 'CustomerContact':
            return 'checkout_contact_info_submitted';
          case 'ShippingAdded':
            return 'checkout_shipping_info_submitted';
          case 'PurchaseAttempt':
            return 'add_payment_info';
          case 'Purchase':
            return 'purchase';
          default:
            return _event.eventName;
        }
      })();
      const mapItems = () => {
        return Array.isArray(_event.cart?.LineItems)
          ? _event.cart?.LineItems?.map((item, idx) => ({
              item_name: item?.Name,
              item_id: item?.ProductID,
              item_brand: item?.Brand,
              item_category: item?.Category,
              item_variant: item?.Subtitle,
              price: item?.UnitPrice,
              quantity: item?.Quantity,
              google_business_vertical: 'retail',
              index: idx,
            }))
          : [];
      };
      if (eventName === 'begin_checkout') {
        console.log(`GTM event: ${eventName} for GTM ID: ${gtmID}`);
        window.dataLayer.push({
          id: _event.eventId,
          event: eventName, // Use the dynamic event name
          ecommerce: {
            currency: _event.cart?.currencyCode || 'USD', // Currency is required
            value: _event.cart?.TotalAmount, // Total Value of Cart Products
            items: mapItems(),
          },
        });
      } else if (eventName === 'add_payment_info') {
        console.log(`GTM event: ${eventName} for GTM ID: ${gtmID}`);
        window.dataLayer.push({
          id: _event.eventId,
          event: eventName, // Use the dynamic event name
          ecommerce: {
            currency: _event.cart?.currencyCode, // Currency is required
            value: _event.cart?.TotalAmount, // Total Value of Cart Products
            payment_type: _event.paymentType,
            items: mapItems(),
          },
        });
      } else if (eventName === 'purchase') {
        console.log(`GTM event: ${eventName} for GTM ID: ${gtmID}`);
        window.dataLayer.push({
          id: _event.eventId,
          event: eventName, //used for creating GTM trigger - Viewed Products in Cart
          ecommerce: {
            currency: _event.cart?.currencyCode,
            value: _event.cart?.TotalAmount, // Total Value of Cart Products
            transaction_id: '12345', // Replace with actual transaction ID
            coupon: 'EUR', // Replace with actual coupon
            tax: 25, // Replace with actual tax amount
            affiliation: 'EUR', // Replace with actual affiliation
            shipping: _event.cart?.Fees,
            items: mapItems(),
          },
        });
      } else {
        console.log(`GTM custom event: ${eventName} for GTM ID: ${gtmID}`);
        window.dataLayer.push({
          event: eventName,
          timeStamp: _event.cart?.UpdatedAt,
          email: _event.cart?.Email,
          phone: _event.cart?.PhoneNumber,
          first_name: _event.cart?.ShippingAddress?.FirstName,
          last_name: _event.cart?.ShippingAddress?.LastName,
          address1: _event.cart?.ShippingAddress?.Address1,
          address2: _event.cart?.ShippingAddress?.Address2,
          city: _event.cart?.ShippingAddress?.City,
          countryCode: _event.cart?.ShippingAddress?.CountryCode,
          provinceCode: _event.cart?.ShippingAddress?.ProvinceCode,
          zip: _event.cart?.ShippingAddress?.Zip,
          orderId: _event.cart?.ID,
          currency: 'USD',
          value: _event.cart?.TotalAmount,
          id: _event.eventId,
          // clientId: _event.cart?.ChannelID,
          url: window.location.href,
          shipping: _event.cart?.Fees,
        });
      }

      console.log(`GTM custom event sent for GTM ID: ${gtmID}`);
      console.log(window.dataLayer, 'dataLayer');
    });
  }
}
